module.exports = __webpack_public_path__ + "img/want.c2666525.png";